var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.775,
    height: 17.875,
    viewBox: "0 0 19.775 17.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_72170",
    "data-name": "Path 72170",
    d: "M17.687,3.063l-5,5.712L8.37,3.063H2.113L9.59,12.839,2.5,20.938H5.538l5.469-6.249,4.78,6.249h6.1L14.1,10.634,20.72,3.063Zm-1.064,16.06L5.654,4.782h1.8L18.3,19.122Z",
    transform: "translate(-2.113 -3.063)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter_icon.72329ee24ab561c5e4fe3287e2c8bb21.svg";
export { ForwardRef as ReactComponent };